import AccountInformation from '@app/components/apps/MyAccount/AccountInformation';
import ResetPassword from '@app/components/apps/MyAccount/ResetPassword';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

import { Row, Col } from 'antd';
import { useEffect } from 'react';

const MyAccountsPage = () => {
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[
          {
            path: '/my-account',
            breadcrumbName: 'My Account',
          },
        ]}
        style={{ marginBottom: '15px' }}
      />,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons]);

  return (
    <>
      <PageTitle>{'My Account'}</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <AccountInformation />
        </Col>
        <Col></Col>
        <Col span={24}>
          <ResetPassword />
        </Col>
      </Row>
    </>
  );
};

export default MyAccountsPage;
